import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.43.0 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V143: ChangelogAdvancedPayload = {
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v143",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v143",
  stats: [
    {
      value: 6,
      labelKey: "changelog.advanced.stat.agenda",
      accentColor: "#0F6E56"
    },
    {
      value: 1,
      labelKey: "changelog.advanced.stat.ai",
      accentColor: "#"
    },
    {
      value: 5,
      labelKey: "changelog.advanced.stat.users",
      accentColor: "#185FA5"
    },
    {
      value: 3,
      labelKey: "changelog.advanced.stat.invoicing",
      accentColor: "#BA7517"
    },

    {
      value: 7,
      labelKey: "changelog.advanced.stat.ux",
      accentColor: "#5F5E5A"
    },
    {
      value: 8,
      labelKey: "changelog.advanced.stat.connectors",
      accentColor: "#534AB7"
    }
  ],
  tabs: [
    {
      id: "agenda",
      labelKey: "changelog.advanced.tab.agenda",
      count: 6,
      sectionLabelKey: "changelog.advanced.section.agenda",
      accentColor: "#0F6E56",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.agenda.snt10025",
          ticket: "SNT-10025"
        },
        {
          textKey: "changelog.advanced.agenda.snt10023",
          ticket: "SNT-10023"
        },
        {
          textKey: "changelog.advanced.agenda.snt10022",
          ticket: "SNT-10022"
        },
        {
          textKey: "changelog.advanced.agenda.snt10026",
          ticket: "SNT-10026"
        },
        {
          textKey: "changelog.advanced.agenda.snt10168",
          ticket: "SNT-10168"
        },
        {
          textKey: "changelog.advanced.agenda.snt10170",
          ticket: "SNT-10170"
        }
      ]
    },
    {
      id: "ai",
      labelKey: "changelog.advanced.tab.ai",
      count: 1,
      sectionLabelKey: "changelog.advanced.section.ai",
      accentColor: "#006288",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.ai.snt10001",
          ticket: "SNT-10001"
        }
      ]
    },
    {
      id: "utenti",
      labelKey: "changelog.advanced.tab.users",
      count: 5,
      sectionLabelKey: "changelog.advanced.section.users",
      accentColor: "#185FA5",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.users.snt10162",
          ticket: "SNT-10162"
        },
        {
          textKey: "changelog.advanced.users.snt10165",
          ticket: "SNT-10165"
        },
        {
          textKey: "changelog.advanced.users.snt10166",
          ticket: "SNT-10166"
        },
        {
          textKey: "changelog.advanced.users.snt10167",
          ticket: "SNT-10167"
        },
        {
          textKey: "changelog.advanced.users.snt10169",
          ticket: "SNT-10169"
        }
      ]
    },
    {
      id: "fatturazione",
      labelKey: "changelog.advanced.tab.billing",
      count: 3,
      sectionLabelKey: "changelog.advanced.section.billing",
      accentColor: "#BA7517",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.billing.snt9826",
          ticket: "SNT-9826"
        },
        {
          textKey: "changelog.advanced.billing.snt10124",
          ticket: "SNT-10124"
        },
        {
          textKey: "changelog.advanced.billing.snt10242",
          ticket: "SNT-10242"
        }
      ]
    },
    {
      id: "ux",
      labelKey: "changelog.advanced.tab.ux",
      count: 7,
      sectionLabelKey: "changelog.advanced.section.ux",
      accentColor: "#5F5E5A",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.ux.snt9966",
          ticket: "SNT-9966"
        },
        {
          textKey: "changelog.advanced.ux.snt10014",
          ticket: "SNT-10014"
        },
        {
          textKey: "changelog.advanced.ux.snt10020",
          ticket: "SNT-10020"
        },
        {
          textKey: "changelog.advanced.ux.snt10108",
          ticket: "SNT-10108"
        },
        {
          textKey: "changelog.advanced.ux.snt9294",
          ticket: "SNT-9294"
        },
        {
          textKey: "changelog.advanced.ux.snt10033",
          ticket: "SNT-10033"
        },
        {
          textKey: "changelog.advanced.ux.snt10200",
          ticket: "SNT-10200"
        }
      ]
    },
    {
      id: "connettori",
      labelKey: "changelog.advanced.tab.connectors",
      count: 8,
      sectionLabelKey: "changelog.advanced.section.connectors",
      accentColor: "#534AB7",
      kind: "connector-grid",
      connectors: [
        {
          name: "DATEV KOINOS",
          metaKey: "changelog.advanced.connector.snt8828"
        },
        {
          name: "IsolabLink",
          metaKey: "changelog.advanced.connector.snt9726"
        },
        {
          name: "AWALIFE AI100Vet",
          metaKey: "changelog.advanced.connector.snt9720"
        },
        {
          name: "SI AMV",
          metaKey: "changelog.advanced.connector.snt9389"
        },
        {
          name: "Italo 400",
          metaKey: "changelog.advanced.connector.snt10224"
        },
        {
          name: "Nazar",
          metaKey: "changelog.advanced.connector.snt10225"
        },
        {
          name: "Coag M",
          metaKey: "changelog.advanced.connector.snt10226"
        },
        {
          name: "2000 XPi",
          metaKey: "changelog.advanced.connector.snt10227"
        }
      ]
    }
  ]
};
